import { get, size } from "lodash";
import { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../apis/axiosInterceptor";
import allImgPaths from "../../assets";
import { DropDownName, DropDownWithCheckBox, TextBox } from "../../components";
import Button from "../../components/common/Button";
import Layout, { Breadcrumb, Container } from "../../components/layout";
import { useAppState } from "../../context";
// import { createQuestionariessubtagSchema } from "../../validations";

interface SubTag {
  tagName: string;
  subTagName: string;
  subTagId: number;
}
interface FormValues {
  title: string;
  subTitle: string;
  sequence: string;
  subTags: SubTag[];
}

const FormQuestionaries = ({ type }: { type: string }) => {
  const navigate = useNavigate();
  const {
    createQuestionariesSubTag,
    updateState,
    curQuestionariesSubTagEditData,
    editQuestionariesSubTag,
    updateQuestionariesSubTag,
  } = useAppState("questionariessubtag");
  const [step] = useState(type);
  const [, setIsChange] = useState(false);
  const params = useParams();
  const [subTagList, setSubTagList] = useState<any>([]);

  const {
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
    control,
  } = useForm<FormValues>({
    defaultValues: {
      title: "",
      subTitle: "",
      sequence: "",
      subTags: [
        {
          tagName: "",
          subTagName: "",
          subTagId: 0,
        },
      ],
    },
    mode: "all",
    reValidateMode: "onChange",
  });

  const {
    fields,
    append,
    remove: removeParameters,
  } = useFieldArray({
    control,
    name: "subTags",
  });

  /* For Edit Questionaries */
  useEffect(() => {
    if (step === "2") {
      editQuestionariesSubTag(params.id);
    }
  }, [step]);
  /* For Edit Questionaries End */
  useEffect(() => {
    const getSubTagList = async () => {
      try {
        const result: any = await api.get("/api/v1/questionnaires/allSubTags");
        const res: { id: number; name: any; _id: string; subId: number }[] = [];
        result.data.data.map((item: any) => {
          res.push({
            id: item.subId,
            name: item.name,
            _id: item._id,
            subId: item.subId,
          });
        });
        setSubTagList(res);
      } catch (error) {
        toast.error("Error while fetching state list");
      }
    };

    getSubTagList();
  }, []);

  useEffect(() => {
    if (step === "2") {
      const tagsArray: string[] = ["tags", "title", "subTitle"];

      if (size(curQuestionariesSubTagEditData) !== 0) {
        tagsArray.forEach((key: any) => {
          setValue(key, get(curQuestionariesSubTagEditData, key, ""));
        });
      }

      const tagsArray1: string[] = ["subTags"];

      if (size(curQuestionariesSubTagEditData) !== 0) {
        tagsArray1.forEach((key: any) => {
          setValue(key, get(curQuestionariesSubTagEditData, key, ""));
        });
      }
    }
  }, [curQuestionariesSubTagEditData]);

  /* For Edit End */
  const onSubmit = async (data: any) => {
    if (step === "1") {
      if (
        await createQuestionariesSubTag({
          ...getValues(),
          questionnaires: params.id,
        })
      ) {
        setTimeout(() => {
          navigate("/questionaries");
        }, 1000);
      }
    }

    if (step === "2") {
      if (
        await updateQuestionariesSubTag({
          questionnaires: params.id,
          ...data,
        })
      ) {
        navigate("/questionaries");
      }
    }
  };

  return (
    <Layout>
      <Breadcrumb />
      <Container>
        <div className="">
          <h1 className="font-semibold text-2xl"></h1>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div className="my-4">
                <label htmlFor="" className="font-medium">
                  Main Title <span className="text-[red]">*</span>
                </label>
                <div className="">
                  <TextBox
                    label="Enter Main Title "
                    name="title"
                    type="text"
                    control={control}
                    errors={errors}
                  />
                </div>
              </div>
              <div className="my-3">
                <label htmlFor="" className="font-medium">
                  Sub Title <span className="text-[red]">*</span>
                </label>
                <div className="">
                  <TextBox
                    label="Enter Sub Title "
                    name="subTitle"
                    type="text"
                    control={control}
                    errors={errors}
                  />
                </div>
              </div>
              <div className="my-3">
                <label htmlFor="" className="font-medium">
                  Tags <span className="text-[red]">*</span>
                </label>
                <div>
                  {fields.map((input, index) => {
                    return (
                      <div
                        className="grid grid-cols-1 gap-4 items-center"
                        key={index + input.id}
                      >
                        <div className="grid grid-cols-3 gap-4">
                          <DropDownName
                            key={`tags${input.id}`}
                            trigger="tags"
                            options={curQuestionariesSubTagEditData.tags || []}
                            name={`subTags[${index}].tagName`}
                            control={control}
                            errors={errors}
                          />
                          <DropDownWithCheckBox
                            key={`subtags${input.id}`}
                            trigger="subTags"
                            name={`subTags[${index}].subTagName`}
                            options={subTagList || []}
                            onChange={(selectedIndices) => {
                              const selectedSubTags = subTagList
                                .filter((item: any) =>
                                  selectedIndices.includes(item.id),
                                )
                                .map((item: any) => item.name);

                              setValue(
                                `subTags.${index}.subTagName`,
                                selectedSubTags,
                              );

                              setValue(
                                `subTags.${index}.subTagId`,
                                selectedIndices,
                              );
                            }}
                            control={control}
                            errors={errors}
                            value={getValues(`subTags.${index}.subTagId`)}
                          />

                          <div className="flex items-center">
                            <div>
                              <button
                                type="button"
                                onClick={() => {
                                  removeParameters(index);
                                  setIsChange(true);
                                }}
                                className="bg-[#D85564] rounded-md h-9"
                              >
                                <img src={allImgPaths.actionTrash} />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <div className="flex items-center justify-start mt-5 gap-7">
                    <div>
                      <Button
                        variant="contained"
                        className="!h-10 !px-4 !text-sm"
                        onClick={() => {
                          append({ tagName: "", subTagName: "", subTagId: 0 });
                          setIsChange(true);
                        }}
                      >
                        Add More..
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center mt-11 gap-5">
                <div>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      updateState({ curQuestionariesSubTagEditData: {} });
                      navigate("/questionaries");
                    }}
                    className="btn-color !h-10 !text-sm !px-4"
                  >
                    Cancel
                  </Button>
                </div>
                <div>
                  <Button
                    variant="contained"
                    className="!h-10 !text-sm"
                    type="submit"
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Container>
    </Layout>
  );
};

export default FormQuestionaries;
